import { Box, FormControl, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import theme from "../theme";

export const MediaHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: 1fr auto auto auto;
  padding-top: 10px;
`;

export const MediaActionBar = styled(Box)`
  display: flex;
  align-items: center;
  padding: 10px 30px;
`;

export const InputSearch = styled(FormControl)`
  margin-right: 10px;
  width: 260px;
`;
export const MediaHeading = styled(Typography)`
  font-weight: bold;
  font-size: medium;
`;

export const MediaContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 30px;
  justify-content: flex-start;
`;

export const MediaItem = styled(Box)`
  position: relative;
  display: flex;
  width: 260px;
  height: 180px;
  border-radius: 10px;
  background: ${theme.palette.grey[100]};
  justify-content: center;
  border: 1px solid #ddd;
  cursor: pointer;
`;

// Add this styled component for the overlay
export const Overlay = styled(Box)`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 30%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
  color: white;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 0 0 10px 10px;
  z-index: 999;
`;

export const ToggleForwardModeButton = styled(IconButton)`
  margin-bottom: 10px;
`;

export const ForwardSelectedMediaButton = styled(IconButton)`
  margin-bottom: 10px;
  margin-left: 4px;
  display: flex;
  gap: 4px;
`;

export const SelectedMediaCount = styled(Typography)`
  font-size: 20px;
  font-weight: 600;
`;
